export default __webpack_public_path__ + "media/images/badge-level1-size16-dd99d8f7246fc076eb50c28a562deea2.png";